import React, { useState } from 'react';
import { GitPullRequestIcon, GitCommitIcon, GitBranchIcon } from 'lucide-react';
import { LinkedGitData } from '../../services/issueGitLinker';
interface GitLinkedBadgesProps {
  linked: LinkedGitData;
  compact?: boolean;
}
export function GitLinkedBadges({
  linked,
  compact = false
}: GitLinkedBadgesProps) {
  const {
    prs,
    commits,
    branches
  } = linked;
  const hasPrs = prs.length > 0;
  const hasCommits = commits.length > 0;
  const hasBranches = branches.length > 0;
  if (!hasPrs && !hasCommits && !hasBranches) return null;
  return <div className="flex items-center gap-1.5" data-id="element-2143">
      {hasPrs && <GitBadge icon={<GitPullRequestIcon size={compact ? 10 : 11} data-id="element-2145" />} count={prs.length} color="text-emerald-400" bgColor="bg-emerald-950/40 border-emerald-900/40" items={prs.map(pr => ({
      label: `#${pr.number} ${pr.title}`,
      url: pr.html_url,
      status: pr.state
    }))} compact={compact} data-id="element-2144" />}
      {hasCommits && <GitBadge icon={<GitCommitIcon size={compact ? 10 : 11} data-id="element-2147" />} count={commits.length} color="text-blue-400" bgColor="bg-blue-950/40 border-blue-900/40" items={commits.slice(0, 5).map(c => ({
      label: (c.commit?.message || c.message || '').split('\n')[0].slice(0, 60),
      url: c.html_url
    }))} compact={compact} data-id="element-2146" />}
      {hasBranches && <GitBadge icon={<GitBranchIcon size={compact ? 10 : 11} data-id="element-2149" />} count={branches.length} color="text-purple-400" bgColor="bg-purple-950/40 border-purple-900/40" items={branches.map(b => ({
      label: b.name
    }))} compact={compact} data-id="element-2148" />}
    </div>;
}
interface GitBadgeProps {
  icon: React.ReactNode;
  count: number;
  color: string;
  bgColor: string;
  items: {
    label: string;
    url?: string;
    status?: string;
  }[];
  compact?: boolean;
}
function GitBadge({
  icon,
  count,
  color,
  bgColor,
  items,
  compact
}: GitBadgeProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  return <div className="relative" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} data-id="element-2150">
      <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border text-[10px] font-medium ${color} ${bgColor} cursor-default`} data-id="element-2151">
        {icon}
        {count > 1 && <span data-id="element-2152">{count}</span>}
      </span>

      {showTooltip && items.length > 0 && <div className="absolute bottom-full left-0 mb-2 z-50 w-64 bg-slate-800 border border-slate-700 rounded-lg shadow-xl p-2 space-y-1 animate-in fade-in zoom-in-95 duration-150" data-id="element-2153">
          {items.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-2154">
              {item.url ? <a href={item.url} target="_blank" rel="noreferrer" className="text-[11px] text-slate-300 hover:text-indigo-400 transition-colors truncate block" onClick={e => e.stopPropagation()} data-id="element-2155">
                  {item.label}
                </a> : <span className="text-[11px] text-slate-300 truncate" data-id="element-2156">
                  {item.label}
                </span>}
              {item.status && <span className={`text-[9px] px-1 py-0.5 rounded shrink-0 ${item.status === 'open' ? 'bg-emerald-950/50 text-emerald-400' : item.status === 'closed' ? 'bg-purple-950/50 text-purple-400' : 'bg-slate-700 text-slate-400'}`} data-id="element-2157">
                  {item.status}
                </span>}
            </div>)}
        </div>}
    </div>;
}